import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import { pillars } from '../shell/navConfig';

export default function PageHeader({ title, description, pillarId, actions }) {
  const pillar = pillars.find((p) => p.id === pillarId);

  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1.5}>
          {pillar && (
            <Chip
              label={pillar.shortLabel}
              size="small"
              sx={{
                fontWeight: 700,
                fontSize: '0.7rem',
                bgcolor: pillar.colorHex + '1a',
                color: pillar.colorHex,
                height: 24,
              }}
            />
          )}
          <Typography variant="h2">{title}</Typography>
        </Stack>
        {actions && <Box>{actions}</Box>}
      </Stack>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, ml: pillar ? 6.5 : 0 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
